import { render, staticRenderFns } from "./lgproject.vue?vue&type=template&id=6d7f03cd&"
import script from "./lgproject.vue?vue&type=script&lang=js&"
export * from "./lgproject.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports